import { useAuth } from '@/App';
import CustomerNavigation from '@/components/CustomerNavigation';
import TwoFactorSettings from '@/components/TwoFactorSettings';
import NotificationSettings from '@/components/NotificationSettings';
import SEO from '@/components/SEO';
import { Settings } from 'lucide-react';

export default function CustomerSettings() {
  const { user } = useAuth();

  return (
    <div className="min-h-screen bg-white flex">
      <SEO 
        title="Innstillinger | Microsafe Kundeportal"
        description="Administrer dine innstillinger, to-faktor autentisering og varsler"
      />
      <CustomerNavigation />
      
      <main className="flex-1 min-h-screen">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 py-6 sm:py-8 animate-fade-in">
          {/* Header */}
          <div className="mb-8">
            <div className="flex items-center gap-3 mb-2">
              <div className="w-10 h-10 bg-slate-900 rounded-xl flex items-center justify-center shadow-lg shadow-slate-900/20">
                <Settings className="w-5 h-5 text-white" />
              </div>
              <div>
                <h1 className="text-2xl font-heading font-bold text-slate-900 tracking-tight" data-testid="settings-title">Innstillinger</h1>
                <p className="text-sm text-slate-500">Administrer dine kontoinnstillinger og varsler</p>
              </div>
            </div>
          </div>

          {/* Settings Cards */}
          <div className="space-y-6">
            <NotificationSettings />
            <TwoFactorSettings user={user} />
          </div>
        </div>
      </main>
    </div>
  );
}
